export default "/assets/images/carbon-monoxide-video-thumbnail.jpg?e430383dc1a2b1170f21d733ae8387b0";